export const getQuantityOfProducts = (products) =>
    products.reduce((sum, { availableServices, qty }) => sum + (isValidProduct(availableServices)
        ? parseInt(qty, 10) : 0), 0);

const isValidProduct = (availableServices) => (availableServices.indexOf('fitting_cost') !== -1);
